/* eslint-disable jsx-a11y/no-redundant-roles */
import React from 'react';
import PropTypes from 'prop-types';
import CybsButton from '@cybs-ui/components/lib/button';
import { StructFlex } from '@cybs-ui/components/lib/struct-flex';

import Icon from '@visa/vds-react/icon-styled';
import classes from './left.styles';

const LeftActionBar = ({ actionBarId, isInvalid, leftActions, headingLevel, i18n }) => {
  const actionCheck = action => {
    if (action instanceof Element) {
      return action;
    }
    return action && <CybsButton dataTest="button-left" {...action} />;
  };
  const getWrapperClass = cssInput =>
    classes(cssInput.classes, cssInput.variables, cssInput.cybs).wrapperDiv;
  const getLeftTitleClass = cssInput =>
    classes(cssInput.classes, cssInput.variables, cssInput.cybs).leftTitle;
  const getSubtitleClass = cssInput =>
    classes(cssInput.classes, cssInput.variables, cssInput.cybs).subtitle;
  const getAditionalSubtitleClass = cssInput =>
    classes(cssInput.classes, cssInput.variables, cssInput.cybs, actionCheck(leftActions[0]))
      .additionalSubtitle;

  return (
    <StructFlex
      direction="row"
      align-items="center"
      flex-wrap="wrap"
      css={getWrapperClass}
    >
      {isInvalid ? <Icon name="error" resolution="tiny" /> : ''}
      {i18n.title && (
        <div css={getLeftTitleClass}>
          <h3
            aria-level={headingLevel}
            id={actionBarId}
            role="heading"
          >
            {i18n.title}
          </h3>
        </div>
      )}
      {i18n.subtitle && <div css={getSubtitleClass}>{i18n.subtitle}</div>}
      {actionCheck(leftActions[0])}
      {i18n.additionalSubtitle && (
        <div css={getAditionalSubtitleClass}>{i18n.additionalSubtitle}</div>
      )}
      {actionCheck(leftActions[1])}
    </StructFlex>
  );
};
LeftActionBar.displayName = 'LeftActionsActionBar';

LeftActionBar.propTypes = {
  /**
  * Level of the heading displayed before the component
  */
  actionBarId: PropTypes.string.isRequired,
  /**
   * Level of the heading displayed before the component
   */
  headingLevel: PropTypes.number,
  /**
   * invalid selection in action bar for grid.
   */
  isInvalid: PropTypes.bool,
  /**
   *  Actions on the left side of the bar. May pass array of button configs
   *  or a react element.
   */
  leftActions: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(
      PropTypes.shape({
        active: PropTypes.bool,
        ariaLabel: PropTypes.string,
        colorScheme: PropTypes.string,
        disabled: PropTypes.func,
        iconClass: PropTypes.string,
        iconLocation: PropTypes.string,
        href: PropTypes.string,
        label: PropTypes.string,
        onClick: PropTypes.func,
        onKeyDown: PropTypes.func,
        variant: PropTypes.string
      })
    )
  ]),
  /**
   * Strings for the component.
   */
  i18n: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    additionalSubtitle: PropTypes.string
  })
};

LeftActionBar.defaultProps = {
  headingLevel: 3,
  isInvalid: false,
  leftActions: [],
  i18n: {}
};
export default LeftActionBar;
